import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {BuyFeatureView} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureView';
import {BuyFeatureModule} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureModule';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';

export class BuyFeatureHiddenState extends ModuleState<BuyFeatureView, BuyFeatureModule> {
    public onEnterState(): void {
        this.view.toggleShowButton(false);
    }

    public onLeaveState(): void {
        this.module.enableShowPopupButtonByName(UIDisableReason.TRIGGERING_FEATURE);
        this.view.toggleShowButton(true);
    }

    protected setupEvents(): void {}
}